import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/(main)/vacancies/[slug]/AboutCompanyCard.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(main)/vacancies/[slug]/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AdminEditVacancyButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslatableTitle","TranslatableLabel","TranslatableDescription"] */ "/app/src/components/TranslatableText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/VacancyActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ViewCounter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ViewTracker.tsx");
